import get from 'lodash/get';
import React from 'react';
import PropTypes from 'prop-types';
import NumberFormatter from '@Utils/NumberFormatter';

import './ShoppingCartTooltipContent.scss';

export const SHOPPING_TOOLTIP_NOT_AVAILABLE = 'Please contact supplier';
export default function ShoppingCartTooltipContent({ details, supplierNumber, className = 'shopping-cart-tooltip--rcs-info', id }) {
  const getValue = (field) => get(details, field, SHOPPING_TOOLTIP_NOT_AVAILABLE);
  const bestPrice = getValue('bestPrice');
  const bestPriceString = parseInt(bestPrice, 10) > 0 ? `${bestPrice} USD/g` : bestPrice;
  return (
    <div className={className} id={id}>
      {supplierNumber !== undefined && supplierNumber !== null && (
        <div>
          Number of Suppliers:<span className="u-els-font-family-bold">&nbsp;{`${NumberFormatter(supplierNumber)}`}</span>
        </div>
      )}
      <div>
        Shipping time:<span className="u-els-font-family-bold">&nbsp;{`${getValue('shippingTime')}`}</span>
      </div>
      <div>
        Best price:<span className="u-els-font-family-bold">&nbsp;{bestPriceString}</span>
      </div>
      <div>
        Largest available package size:<span className="u-els-font-family-bold">&nbsp;{`${getValue('maxPackSize')}`}</span>
      </div>
    </div>
  );
}

ShoppingCartTooltipContent.propTypes = {
  details: PropTypes.object.isRequired,
  className: PropTypes.string,
  supplierNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
};
